// Documenti legali e pagina trasparenza. Aggiornare VERSIONE e DATA a ogni modifica del testo:
// la versione accettata viene registrata insieme al consenso di ogni cliente.
export const LEGALE_VERSIONE = "1.2";
export const LEGALE_DATA = "23/09/2026";
export const TITOLARE_SERVIZIO = "Ivan Viglierco (Viglietron Project)";
export const EMAIL_CONTATTO = "viglietronproject@gmail.com";

const IT = {
  termini: {
    titolo: "Condizioni di utilizzo",
    intro:
      "Queste condizioni regolano l'uso di Reprehendo (RH), gestionale per ristoranti, pizzerie e bar. " +
      "Usando il servizio le accetti. Sono scritte in modo semplice di proposito: se una parte non ti è chiara, chiedi prima di firmare.",
    sezioni: [
      {
        t: "Chi fornisce il servizio",
        p: [
          `Il servizio è fornito da ${TITOLARE_SERVIZIO}, che puoi contattare a ${EMAIL_CONTATTO}.`,
          "Reprehendo è un software che si usa via internet: non installi nulla e non gestisci tu i server.",
        ],
      },
      {
        t: "Versione beta: cosa significa davvero",
        p: [
          "Il prodotto è in versione beta: funziona ed è usato in servizio reale, ma è in evoluzione continua.",
          "Possono capitare interruzioni, rallentamenti o comportamenti imprevisti. Quando accade, l'impegno è correggere in tempi rapidi e dirti cosa è successo.",
          "Non promettiamo una disponibilità garantita al 100%: nessun fornitore serio lo fa, e chi lo promette non ti sta dicendo tutto.",
        ],
      },
      {
        t: "Su cosa gira il servizio (trasparenza)",
        p: [
          "L'applicazione è ospitata su infrastruttura di terzi (piattaforma cloud e database gestito). Non è hardware di proprietà del fornitore del servizio.",
          "Se l'infrastruttura di terzi ha un guasto, il servizio può risultare non raggiungibile anche se il software è corretto: è il limite fisiologico di qualunque servizio in cloud.",
          "Per questo i dati vengono copiati ogni notte e puoi scaricarne una copia completa in qualsiasi momento dalla pagina Backup.",
        ],
      },
      {
        t: "Non sostituisce il registratore di cassa",
        p: [
          "Reprehendo gestisce comande, conti e incassi per uso interno e organizzativo.",
          "I documenti stampati (conto, riepiloghi, quadrature) NON sono documenti fiscali e non sostituiscono lo scontrino, la ricevuta o il registratore telematico.",
          "Gli obblighi fiscali, di certificazione dei corrispettivi e di conservazione restano interamente a carico dell'esercente.",
        ],
      },
      {
        t: "I tuoi dati restano tuoi",
        p: [
          "Menu, tavoli, comande, incassi, magazzino e clienti sono dati tuoi. Puoi scaricarli quando vuoi in un file completo.",
          "Se smetti di usare il servizio, puoi chiedere l'esportazione e la cancellazione definitiva.",
          "Ogni attività lavora su dati separati da quelli delle altre.",
        ],
      },
      {
        t: "Uso corretto",
        p: [
          "Custodisci i codici di accesso e i PIN del personale: chi li ha può operare a tuo nome.",
          "Non è consentito rivendere il servizio, cedere l'accesso a terzi estranei all'attività, tentare di forzarlo o usarlo per attività illecite.",
          "Le persone che inserisci devono essere informate del fatto che le loro azioni nel gestionale sono registrate (chi ha incassato, chi ha annullato, chi ha applicato uno sconto).",
        ],
      },
      {
        t: "Prezzi, prova e disdetta",
        p: [
          "La prova gratuita dura 7 giorni, senza carta di credito e senza rinnovo automatico.",
          "I prezzi indicati sono indicativi e IVA esclusa: essendo in beta possono cambiare, e ogni variazione verrà comunicata prima di applicarla.",
          "L'abbonamento si disdice quando vuoi: resta attivo fino alla fine del periodo già pagato, senza penali.",
        ],
      },
      {
        t: "Limiti di responsabilità",
        p: [
          "Il fornitore risponde dei propri errori, non di eventi fuori dal suo controllo: guasti dell'infrastruttura di terzi, mancanza di connessione nel locale, guasti dei dispositivi, uso improprio o errori di inserimento del personale.",
          "Non è dovuto alcun risarcimento per mancato guadagno, perdita di clientela o danni indiretti.",
          "Nei limiti massimi consentiti dalla legge, l'eventuale responsabilità è comunque limitata a quanto pagato per il servizio negli ultimi tre mesi.",
          "Nessuna clausola di questo documento esclude i diritti che la legge riconosce come inderogabili.",
        ],
      },
      {
        t: "Interruzioni e chiusura del servizio",
        p: [
          "Gli aggiornamenti vengono fatti, quando possibile, fuori dagli orari di servizio.",
          "Se il servizio dovesse cessare, riceverai un preavviso di almeno 30 giorni e il tempo di scaricare tutti i tuoi dati.",
          "L'accesso può essere sospeso in caso di mancato pagamento o di uso che mette a rischio gli altri clienti, con avviso e possibilità di rimediare.",
        ],
      },
      {
        t: "Modifiche, legge applicabile",
        p: [
          "Queste condizioni possono cambiare: la versione e la data sono sempre in testa al documento e le modifiche rilevanti vengono comunicate per email.",
          "Si applica la legge italiana. Per le controversie è competente il foro del luogo in cui ha sede il fornitore del servizio, salvo i casi in cui la legge preveda il foro del consumatore.",
        ],
      },
    ],
  },

  privacy: {
    titolo: "Informativa privacy",
    intro:
      "Come vengono trattati i dati personali quando usi Reprehendo, ai sensi del Regolamento europeo 2016/679 (GDPR). " +
      "Nessun dato viene venduto, ceduto o usato per pubblicità.",
    sezioni: [
      {
        t: "Chi tratta i dati e con quale ruolo",
        p: [
          `Per i dati di chi si registra (email del titolare, nome dell'attività, pagamenti) il titolare del trattamento è ${TITOLARE_SERVIZIO}, contattabile a ${EMAIL_CONTATTO}.`,
          "Per i dati inseriti dentro il gestionale (personale, clienti, prenotazioni) il titolare del trattamento è il ristoratore: il fornitore agisce come responsabile del trattamento, cioè tratta quei dati solo per far funzionare il servizio e secondo le istruzioni del ristoratore.",
          "Accettando le condizioni, questa informativa vale anche come nomina a responsabile del trattamento ai sensi dell'art. 28 GDPR.",
        ],
      },
      {
        t: "Quali dati e perché",
        p: [
          "Registrazione: nome dell'attività, email, lingua, dati di fatturazione. Servono a creare l'accesso, inviare le credenziali e gestire l'abbonamento.",
          "Personale: nome e PIN di accesso, ruolo, stato. Servono a far lavorare le persone e a sapere chi ha fatto cosa.",
          "Clienti del locale: nome, telefono, note e storico delle visite, se il ristoratore li inserisce per prenotazioni e lista d'attesa.",
          "Uso del servizio: registro delle azioni (chi ha incassato, annullato, scontato) per sicurezza e per risolvere le contestazioni.",
          "Questionari di gradimento: voto e commento, per migliorare il prodotto. L'email è facoltativa.",
          "Richieste di contatto dalla demo: nome dell'attività, città e telefono di chi, dopo la prova guidata, chiede di essere richiamato. Servono solo a quella telefonata: non vengono usate per pubblicità e si cancellano su richiesta o dopo 12 mesi dall'ultimo contatto.",
          "Assistenza all'avvio: per aiutare chi si è appena registrato, il fornitore vede lo stato di configurazione del locale (quante sale, tavoli, piatti e persone sono stati inseriti) e la data dell'ultimo accesso, e può contattare il referente indicato in fase di registrazione. Non vede incassi, nomi dei clienti del locale né il contenuto delle comande.",
        ],
      },
      {
        t: "Base giuridica",
        p: [
          "Esecuzione del contratto per tutto ciò che serve a far funzionare il servizio e a fatturare.",
          "Legittimo interesse per la sicurezza, i registri delle azioni e i backup.",
          "Legittimo interesse ad assistere il cliente nella messa in funzione del servizio: puoi chiedere di non essere ricontattato scrivendo all'indirizzo di contatto.",
          "Consenso per i questionari facoltativi e per le comunicazioni non necessarie al servizio, revocabile in qualsiasi momento.",
          "Obbligo di legge per la conservazione dei documenti fiscali e contabili.",
        ],
      },
      {
        t: "Dove stanno i dati e chi li vede",
        p: [
          "I dati sono ospitati su infrastruttura cloud gestita dal fornitore della piattaforma (Emergent), nominato responsabile del trattamento con accordo DPA disponibile su app.emergent.sh/dpa.",
          "Il trattamento avviene in Stati Uniti, Unione Europea e India: i trasferimenti fuori dall'Unione Europea avvengono con le garanzie previste dal GDPR (clausole contrattuali standard).",
          "Fornitori coinvolti: piattaforma di hosting e database (Emergent), servizio di invio email (per credenziali, promemoria e backup), servizio di pagamento (per gli abbonamenti), servizio di sintesi vocale (che riceve solo il testo della comanda da leggere, senza dati dei clienti).",
          "Ogni fornitore tratta i dati solo per la propria funzione, su nostra istruzione e senza poterli usare per scopi propri.",
          "Nessun cookie di profilazione e nessuno strumento di tracciamento pubblicitario: l'app usa solo la memoria locale del dispositivo per tenerti collegato.",
        ],
      },
      {
        t: "Per quanto tempo",
        p: [
          "Dati dell'attività: per tutta la durata del rapporto. Alla chiusura vengono cancellati entro 30 giorni, salvo obblighi fiscali.",
          "Prove gratuite non convertite: il locale di prova e i suoi dati vengono eliminati automaticamente 14 giorni dopo la scadenza.",
          "Copie di backup: le copie notturne restano disponibili 7 giorni, poi vengono sovrascritte.",
          "Registro delle azioni: 12 mesi.",
          "Richieste di contatto dalla demo: 12 mesi dall'ultimo contatto.",
        ],
      },
      {
        t: "I tuoi diritti",
        p: [
          "Puoi chiedere accesso, correzione, cancellazione, limitazione, portabilità dei dati e opporti al trattamento, scrivendo all'indirizzo di contatto.",
          "La risposta arriva entro 30 giorni. Puoi revocare i consensi facoltativi in qualsiasi momento.",
          "Se ritieni che i tuoi dati siano trattati in modo scorretto puoi rivolgerti al Garante per la protezione dei dati personali.",
        ],
      },
      {
        t: "Sicurezza e violazioni",
        p: [
          "Accesso protetto da codice attività e PIN personale, con blocco dopo tre tentativi errati; PIN e password conservati in forma cifrata; dati di ogni attività separati.",
          "In caso di violazione dei dati che comporti un rischio per le persone, i clienti interessati vengono avvisati senza ritardo e, quando previsto, viene informato il Garante entro 72 ore.",
          "Essendo un servizio in beta su infrastruttura di terzi, la trasparenza è parte del patto: cosa è accaduto e cosa è stato fatto viene comunicato per iscritto.",
        ],
      },
    ],
  },

  sicurezza: {
    titolo: "Sicurezza e custodia dei dati",
    intro:
      "Come sono protetti i dati del tuo locale, scritto in modo che si capisca. Se qualcosa qui non ti torna, scrivici prima di attivare la prova.",
    sezioni: [
      {
        t: "I dati del tuo locale sono solo tuoi",
        p: [
          "Ogni attività ha i propri archivi separati: menu, tavoli, comande, incassi e personale di un locale non sono raggiungibili da un altro locale.",
          "La separazione non è affidata alle singole ricerche: è applicata da un unico punto di controllo che accompagna ogni richiesta. Un errore di programmazione in una pagina non può far uscire i dati dal locale.",
          "Il collegamento è sempre cifrato (HTTPS) sul dominio del servizio.",
        ],
      },
      {
        t: "Password, codici e PIN",
        p: [
          "Il codice della tua attività e i PIN del personale non sono conservati in chiaro: nel sistema resta solo un'impronta cifrata (bcrypt), dalla quale non si può risalire al codice originale. Nemmeno noi possiamo leggerli.",
          "Dopo cinque tentativi sbagliati l'accesso si blocca automaticamente per qualche minuto, per indirizzo di provenienza: chi prova a indovinare i codici a raffica viene fermato.",
          "L'accesso alla console del fornitore richiede una password lunga più un codice usa e getta inviato per email: conoscere solo la password non basta.",
          "Non chiediamo mai password o dati della carta per email. Se ricevi una richiesta simile, non è nostra.",
        ],
      },
      {
        t: "Copie di sicurezza",
        p: [
          "Ogni notte viene creata una copia dei dati di ogni locale, cifrata a riposo (AES-GCM) prima di essere conservata.",
          "Il titolare può scaricare in qualsiasi momento un file con tutti i propri dati, dalla sezione Backup dell'app.",
          "I link di scaricamento hanno una scadenza e ogni scarico viene contato.",
        ],
      },
      {
        t: "Chi può fare cosa, e ne resta traccia",
        p: [
          "Ogni persona entra con il proprio PIN e le operazioni restano a suo nome: annulli, sconti, incassi e passaggi di cassa sono attribuiti a chi li ha fatti.",
          "Le operazioni del fornitore (attivazioni, cambi di piano, sospensioni, cancellazioni) finiscono in un registro in sola aggiunta, che nessuna pagina può cancellare.",
        ],
      },
      {
        t: "Cancellazione e conservazione",
        p: [
          "Puoi chiedere la cancellazione definitiva del tuo locale dall'app: la richiesta viene confermata via email e nulla viene toccato finché non confermi.",
          "Prove non convertite: i dati restano 30 giorni dopo la scadenza, con un avviso via email tre giorni prima della cancellazione e il link per scaricare tutto.",
          "Alla cancellazione vengono rimossi anche le copie di sicurezza e le sessioni aperte.",
        ],
      },
      {
        t: "Cosa non promettiamo",
        p: [
          "Reprehendo è in versione beta: preferiamo dire cosa non c'è, piuttosto che farlo scoprire dopo.",
          "Non abbiamo (ancora) certificazioni formali di sicurezza né la conservazione fiscale certificata dello scontrino elettronico.",
          "L'infrastruttura è fornita da terze parti: il trattamento avviene in Stati Uniti, Unione Europea e India, con le garanzie previste dal GDPR.",
          "Se accade un incidente che riguarda i dati, i clienti interessati vengono avvisati senza ritardo e per iscritto.",
        ],
      },
    ],
  },

  stato: {
    titolo: "Stato del servizio e impegni",
    intro:
      "Cosa puoi aspettarti concretamente da noi. Preferiamo scriverlo prima, non quando serve.",
    sezioni: [
      {
        t: "Dove siamo oggi",
        p: [
          "Reprehendo è in versione beta: usato in servizio reale, in sviluppo continuo.",
          "Le nuove funzioni vengono provate su un ambiente separato prima di arrivare ai clienti.",
          "Il manuale dentro l'app viene aggiornato a ogni novità: se leggi una cosa lì, l'app la fa.",
        ],
      },
      {
        t: "I nostri impegni",
        p: [
          "Backup automatico ogni notte, con copia scaricabile in qualsiasi momento dalla pagina Backup.",
          "Risposta alle segnalazioni entro 1 giorno lavorativo; per i blocchi che fermano il servizio, presa in carico immediata.",
          "Nessuna modifica ai prezzi senza preavviso; nessun rinnovo automatico nascosto.",
          "Preavviso di almeno 30 giorni se il servizio dovesse chiudere, con tutto il tempo di portare via i dati.",
        ],
      },
      {
        t: "Cosa non possiamo promettere",
        p: [
          "Disponibilità garantita al 100%: il servizio gira su infrastruttura di terzi e nessuno può escludere un guasto.",
          "Funzionamento senza connessione: senza rete l'app resta in lettura, le azioni non si registrano.",
          "Sostituzione del registratore di cassa fiscale: non lo è e non vuole esserlo.",
        ],
      },
      {
        t: "Come segnalare un problema",
        p: [
          `Scrivi a ${EMAIL_CONTATTO} indicando nome dell'attività, cosa stavi facendo e, se puoi, una fotografia dello schermo.`,
          "I questionari dentro l'app arrivano direttamente a chi sviluppa il prodotto: le richieste dei ristoratori decidono cosa fare prima.",
        ],
      },
    ],
  },
};

const EN = {
  termini: {
    titolo: "Terms of use",
    intro:
      "These terms govern the use of Reprehendo (RH), management software for restaurants, pizzerias and bars. " +
      "By using the service you accept them. They are deliberately written in plain language: if anything is unclear, ask before you sign.",
    sezioni: [
      {
        t: "Who provides the service",
        p: [
          `The service is provided by ${TITOLARE_SERVIZIO}, who can be reached at ${EMAIL_CONTATTO}.`,
          "Reprehendo is software used over the internet: you install nothing and you do not run the servers.",
        ],
      },
      {
        t: "Beta version: what it really means",
        p: [
          "The product is in beta: it works and is used in real service, but it evolves continuously.",
          "Outages, slowdowns or unexpected behaviour can happen. When they do, the commitment is to fix them quickly and tell you what happened.",
          "We do not promise 100% guaranteed uptime: no serious provider does, and whoever promises it is not telling you everything.",
        ],
      },
      {
        t: "What the service runs on (transparency)",
        p: [
          "The application is hosted on third-party infrastructure (cloud platform and managed database). The hardware does not belong to the service provider.",
          "If the third-party infrastructure fails, the service may be unreachable even when the software is fine: that is the inherent limit of any cloud service.",
          "That is why data is copied every night and you can download a full copy at any time from the Backup page.",
        ],
      },
      {
        t: "It does not replace a fiscal till",
        p: [
          "Reprehendo handles orders, bills and takings for internal and organisational use.",
          "Printed documents (bill, summaries, reconciliations) are NOT fiscal documents and do not replace receipts or a certified fiscal register.",
          "Tax obligations, certification of takings and record keeping remain entirely with the business owner.",
        ],
      },
      {
        t: "Your data stays yours",
        p: [
          "Menu, tables, orders, takings, stock and guests are your data. You can download them any time in a complete file.",
          "If you stop using the service you can request an export and permanent deletion.",
          "Each venue works on data kept separate from every other venue.",
        ],
      },
      {
        t: "Fair use",
        p: [
          "Keep access codes and staff PINs safe: whoever has them can act in your name.",
          "You may not resell the service, give access to third parties outside your business, attempt to break it or use it for unlawful activity.",
          "The people you add must be informed that their actions in the system are logged (who took payment, who voided, who applied a discount).",
        ],
      },
      {
        t: "Prices, trial and cancellation",
        p: [
          "The free trial lasts 7 days, with no card details and no automatic renewal.",
          "Listed prices are indicative and exclude VAT: being in beta they may change, and any change will be announced before it applies.",
          "You can cancel any time: the subscription stays active until the end of the period already paid, with no penalty.",
        ],
      },
      {
        t: "Limits of liability",
        p: [
          "The provider answers for its own mistakes, not for events beyond its control: third-party infrastructure failures, no connection at the venue, device failures, misuse or data-entry mistakes by staff.",
          "No compensation is due for lost profit, lost custom or indirect damage.",
          "To the fullest extent permitted by law, liability is in any case limited to the amount paid for the service in the last three months.",
          "Nothing in this document excludes rights that the law makes mandatory.",
        ],
      },
      {
        t: "Interruptions and closure",
        p: [
          "Updates are carried out outside service hours whenever possible.",
          "Should the service ever close, you will get at least 30 days' notice and time to download all your data.",
          "Access may be suspended for non-payment or for use that puts other customers at risk, with notice and a chance to put things right.",
        ],
      },
      {
        t: "Changes and applicable law",
        p: [
          "These terms may change: version and date are always at the top of the document and material changes are announced by email.",
          "Italian law applies. Disputes fall under the court where the provider is based, except where the law provides for the consumer's court.",
        ],
      },
    ],
  },

  privacy: {
    titolo: "Privacy notice",
    intro:
      "How personal data is handled when you use Reprehendo, under European Regulation 2016/679 (GDPR). " +
      "No data is ever sold, shared or used for advertising.",
    sezioni: [
      {
        t: "Who handles the data and in which role",
        p: [
          `For sign-up data (owner email, venue name, payments) the data controller is ${TITOLARE_SERVIZIO}, reachable at ${EMAIL_CONTATTO}.`,
          "For data entered inside the system (staff, guests, bookings) the data controller is the restaurant owner: the provider acts as data processor, handling that data only to run the service and following the owner's instructions.",
          "By accepting the terms, this notice also serves as the data processing appointment under art. 28 GDPR.",
        ],
      },
      {
        t: "What data and why",
        p: [
          "Sign-up: venue name, email, language, billing details. Needed to create access, send credentials and manage the subscription.",
          "Staff: name and access PIN, role, state. Needed to let people work and to know who did what.",
          "Venue guests: name, phone, notes and visit history, if the owner enters them for bookings and the waiting list.",
          "Service usage: an action log (who took payment, voided, discounted) for security and to settle disputes.",
          "Feedback forms: rating and comment, to improve the product. Email is optional.",
          "Contact requests from the demo: business name, town and phone number left by anyone who asks to be called back after the guided demo. Used only for that call, never for advertising, deleted on request or after 12 months from the last contact.",
          "Onboarding assistance: to help a newly registered venue, the provider can see the setup progress (how many rooms, tables, dishes and people have been entered) and the date of the last sign-in, and may contact the person named at sign-up. The provider does not see takings, venue guest names or order contents.",
        ],
      },
      {
        t: "Legal basis",
        p: [
          "Performance of the contract for everything needed to run the service and invoice it.",
          "Legitimate interest for security, action logs and backups.",
          "Legitimate interest in helping the customer get the service up and running: you can ask not to be contacted again by writing to the contact address.",
          "Consent for optional feedback and non-essential communications, withdrawable at any time.",
          "Legal obligation for keeping tax and accounting records.",
        ],
      },
      {
        t: "Where the data is and who sees it",
        p: [
          "Data is hosted on cloud infrastructure managed by the platform provider (Emergent), appointed as data processor under the DPA available at app.emergent.sh/dpa.",
          "Processing takes place in the United States, the European Union and India: transfers outside the European Union rely on GDPR safeguards (standard contractual clauses).",
          "Providers involved: hosting and database platform (Emergent), email delivery service (credentials, reminders, backups), payment service (subscriptions), speech service (which only receives the order text to read out, with no guest data).",
          "Each provider handles data only for its own function, on our instructions and never for its own purposes.",
          "No profiling cookies and no advertising trackers: the app only uses the device's local storage to keep you signed in.",
        ],
      },
      {
        t: "How long",
        p: [
          "Venue data: for the whole duration of the relationship. On closure it is deleted within 30 days, unless tax law requires otherwise.",
          "Unconverted free trials: the trial venue and its data are deleted automatically 14 days after expiry.",
          "Backups: nightly copies stay available for 7 days, then they are overwritten.",
          "Action log: 12 months.",
          "Contact requests from the demo: 12 months from the last contact.",
        ],
      },
      {
        t: "Your rights",
        p: [
          "You can request access, correction, deletion, restriction, portability and object to processing, by writing to the contact address.",
          "You get an answer within 30 days. Optional consents can be withdrawn at any time.",
          "If you believe your data is handled improperly you can complain to the Italian data protection authority.",
        ],
      },
      {
        t: "Security and breaches",
        p: [
          "Access protected by venue code and personal PIN, locked after three wrong attempts; PINs and passwords stored encrypted; each venue's data kept separate.",
          "In case of a data breach posing a risk to people, affected customers are notified without delay and, where required, the authority within 72 hours.",
          "As a beta service on third-party infrastructure, transparency is part of the deal: what happened and what was done is put in writing.",
        ],
      },
    ],
  },

  sicurezza: {
    titolo: "Security and data custody",
    intro:
      "How your venue's data is protected, written so it can be understood. If anything here does not add up, write to us before starting a trial.",
    sezioni: [
      {
        t: "Your venue's data is yours alone",
        p: [
          "Each business has its own separate archives: menu, tables, orders, takings and staff of one venue cannot be reached from another venue.",
          "Separation is not left to individual queries: it is enforced at a single control point that travels with every request. A coding mistake on one page cannot leak data outside the venue.",
          "The connection is always encrypted (HTTPS) on the service domain.",
        ],
      },
      {
        t: "Passwords, codes and PINs",
        p: [
          "Your venue code and staff PINs are never stored in clear text: only an encrypted fingerprint (bcrypt) is kept, from which the original cannot be recovered. Not even we can read them.",
          "After five wrong attempts access locks automatically for a few minutes, per originating address: anyone trying to guess codes in bulk is stopped.",
          "Access to the vendor console requires a long password plus a one-time code sent by email: knowing the password alone is not enough.",
          "We never ask for passwords or card details by email. If you get such a request, it is not from us.",
        ],
      },
      {
        t: "Backups",
        p: [
          "Every night a copy of each venue's data is created and encrypted at rest (AES-GCM) before being stored.",
          "The owner can download a file with all their data at any time, from the Backup section of the app.",
          "Download links expire and every download is counted.",
        ],
      },
      {
        t: "Who can do what, and it is recorded",
        p: [
          "Everyone signs in with their own PIN and operations stay in their name: cancellations, discounts, takings and cash handovers are attributed to whoever made them.",
          "Vendor operations (activations, plan changes, suspensions, deletions) go into an append-only log that no page can erase.",
        ],
      },
      {
        t: "Deletion and retention",
        p: [
          "You can request permanent deletion of your venue from the app: the request is confirmed by email and nothing is touched until you confirm.",
          "Trials that are not converted: data is kept for 30 days after expiry, with an email warning three days before deletion and a link to download everything.",
          "On deletion, backups and open sessions are removed too.",
        ],
      },
      {
        t: "What we do not promise",
        p: [
          "Reprehendo is in beta: we would rather say what is missing than let you find out later.",
          "We do not (yet) hold formal security certifications, nor certified fiscal storage of electronic receipts.",
          "Infrastructure is provided by third parties: processing takes place in the United States, the European Union and India, with the safeguards required by the GDPR.",
          "If an incident affecting data occurs, affected customers are notified without delay and in writing.",
        ],
      },
    ],
  },

  stato: {
    titolo: "Service status and commitments",
    intro: "What you can realistically expect from us. We prefer to write it down before it is needed.",
    sezioni: [
      {
        t: "Where we are today",
        p: [
          "Reprehendo is in beta: used in real service, under continuous development.",
          "New features are tried on a separate environment before they reach customers.",
          "The in-app manual is updated with every change: if you read it there, the app does it.",
        ],
      },
      {
        t: "Our commitments",
        p: [
          "Automatic backup every night, with a copy downloadable at any time from the Backup page.",
          "Answer to reports within 1 working day; immediate handling for anything that stops service.",
          "No price change without notice; no hidden automatic renewal.",
          "At least 30 days' notice should the service ever close, with all the time needed to take your data away.",
        ],
      },
      {
        t: "What we cannot promise",
        p: [
          "100% guaranteed uptime: the service runs on third-party infrastructure and nobody can rule out a failure.",
          "Working without a connection: with no network the app stays read-only, actions are not recorded.",
          "Replacing a fiscal till: it is not one and does not aim to be.",
        ],
      },
      {
        t: "How to report a problem",
        p: [
          `Write to ${EMAIL_CONTATTO} with the venue name, what you were doing and, if you can, a photo of the screen.`,
          "Feedback forms inside the app go straight to whoever develops the product: what restaurateurs ask for decides what gets built first.",
        ],
      },
    ],
  },
};

export const legale = (lang) => (lang === "it" ? IT : EN);
